import React from 'react';

/*
import {
  hf,
  ht,
  cr,
  useMsgz,
  a,
  ls,
  f,
  BoxC,
  BtnC,
  BtnCttC,
  IptC,
  LblC,
  TblC,
  TextC,
  GridC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as LblC from "./_cccLblC";
import * as BtnCttC from "./_ccmBtnCttC";
import * as TblC from "./_ccmTblC";
import * as cmFTH from "./_cmFTH"; // 廃止予定
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ls from "./_csLcl"; // local state
import { useMsgz } from "./_csMdlMsg";
import * as ht from './_ht';
import * as hf from './_hf';

import * as ica from 'src/ica';
import * as ict from 'src/ict';

import * as icvi11 from './icvI11___Mz';

let $i11z = icvi11.ilzI11z();

export const B = (pz: ht.btnCttCz) => {
  const _sMsgz = useMsgz();
  return (
    cr.c(BtnCttC.N, {
      key: -10,
      ... pz,
      cz: {
        ... pz.cz,
        ugdAsync: async () => {
          const _i11rz = $i11z.i11rz;
          const _b = await hf.ectSrlAsync([
            async () => { // 必須項目の確認
              let _b = true;
              if (
                !hf.f(_i11rz._icn) || // 部屋ID
                !hf.f(_i11rz._pfx) // 部屋名
              ) _b = false;
              if (!_b) {
                _sMsgz.show({
                  textCz: {
                    textz: {
                      pfx: '必須項目が入力されていないため、指定された操作を行うことができません',
                    }
                  }
                })
              }
              return _b;
            },
          ])
          if (_b) {
            const _i11z = await icvi11.saveI11rDzAsync({
              ... pz,
              i11z: $i11z,
            });
            return {
              i11r_fst :_i11z.i11rz._fst,
            };
          }
        }
      }
    })
  );
};

export const D = (pz: ht.viewDtlCz) => {

  const _frcUdt = ls.frcUdt();

  React.useEffect(() => {
    cmFTH.loadAllAsync({
      phs: pz.sPz.crt.phs,
      frcUdt: _frcUdt,
      crtAsync: () => [
        icvi11.crtI11zAsync()
        .then((_dz: ht.dz) => {
          $i11z = _dz;
        })
      ],
      udtAsync: () => [
        icvi11.loadI11rDzAsync({
          i11r_fst: pz.sPz.crt.i11r_fst,
          vsn: pz.sPz.crt.vsn,
        })
        .then((_dz: ict.i11z) => {
          $i11z = _dz;
        })
      ],
    })
  }, [
    pz.sPz.crt.phs,
    pz.sPz.crt.i11r_fst,
    pz.sPz.crt.vsn,
  ])

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewDtlAbtz[_abtType] ? ica.viewDtlAbtz[_abtType]() : {};

  const _hdrs1 = [] as ht.ls;
  _hdrs1.push({
    cellCs: [
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            ... _abtz.cldz.hdrCz.textCz,
            textz: {
              pfx: 'ID'
            }
          })
        ]
      },
      {
        boxStlz: a('dw/10 f/n'),
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            ... _abtz.cldz.hdrCz.textCz,
            textz: {
              pfx: '時間帯名'
            }
          })
        ]
      },
      {
        boxStlz: a('dw/10 f/n'),
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            ... _abtz.cldz.hdrCz.textCz,
            textz: {
              pfx: '　'
            }
          })
        ]
      },
      {
        boxStlz: a('f/3'),
        oClds: [
          cr.c(GridC.N, {
            key: -10,
            abtType: 'nolineCmnz',
            lineCs: [
              {
                boxStlz: a('mb/0'),
                cellCs: [
                  {
//                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '１種'
                        }
                      })
                    ]
                  }
                ],
              },
              {
                boxStlz: a('mb/0'),
                cellCs: [
                  {
//                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '通常月'
                        }
                      })
                    ]
                  }
                ],
              },
              {
                boxStlz: a('mb/0'),
                cellCs: [
                  {
//                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '平日'
                        }
                      }),
                    ]
                  },
                  {
//s                    boxStlz: a('fd/rsc'),
                    oClds: [                
                      cr.c(TextC.N, {
                        key: -20,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '土曜'
                        }
                      }),
                    ]
                  },
                  {
//                    boxStlz: a('fd/rsc'),
                    oClds: [                
                      cr.c(TextC.N, {
                        key: -30,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '日祝'
                        }
                      })
                    ]
                  }
                ],
              },
            ],
          }),
        ]
      },
      {
        boxStlz: a('f/3'),
        oClds: [
          cr.c(GridC.N, {
            key: -10,
            abtType: 'nolineCmnz',
            lineCs: [
              {
                boxStlz: a('mb/0'),
                cellCs: [
                  {
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '　'
                        }
                      })
                    ]
                  }
                ],
              },
              {
                boxStlz: a('mb/0'),
                cellCs: [
                  {
//                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '夏時間'
                        }
                      })
                    ]
                  }
                ],
              },
              {
//                boxStlz: a('mb/0'),
                cellCs: [
                  {
//                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '平日'
                        }
                      }),
                    ]
                  },
                  {
//                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -20,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '土曜'
                        }
                      }),
                    ]
                  },
                  {
//                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -30,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '日祝'
                        }
                      })
                    ]
                  }
                ],
              },
            ],
          }),
        ]
      },
      {
        boxStlz: a('f/3'),
        oClds: [
          cr.c(GridC.N, {
            key: -10,
            abtType: 'nolineCmnz',
            lineCs: [
              {
                boxStlz: a('mb/0'),
                cellCs: [
                  {
//                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '２種'
                        }
                      })
                    ]
                  }
                ],
              },
              {
                boxStlz: a('mb/0'),
                cellCs: [
                  {
//                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '通常月'
                        }
                      })
                    ]
                  }
                ],
              },
              {
                boxStlz: a('mb/0'),
                cellCs: [
                  {
//                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '平日'
                        }
                      }),
                    ]
                  },
                  {
//s                    boxStlz: a('fd/rsc'),
                    oClds: [                
                      cr.c(TextC.N, {
                        key: -20,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '土曜'
                        }
                      }),
                    ]
                  },
                  {
//                    boxStlz: a('fd/rsc'),
                    oClds: [                
                      cr.c(TextC.N, {
                        key: -30,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '日祝'
                        }
                      })
                    ]
                  }
                ],
              },
            ],
          }),
        ]
      },
      {
        boxStlz: a('f/3'),
        oClds: [
          cr.c(GridC.N, {
            key: -10,
            abtType: 'nolineCmnz',
            lineCs: [
              {
                boxStlz: a('mb/0'),
                cellCs: [
                  {
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '　'
                        }
                      })
                    ]
                  }
                ],
              },
              {
                boxStlz: a('mb/0'),
                cellCs: [
                  {
//                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '夏時間'
                        }
                      })
                    ]
                  }
                ],
              },
              {
                boxStlz: a('mb/0'),
                cellCs: [
                  {
//                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '平日'
                        }
                      }),
                    ]
                  },
                  {
//                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -20,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '土曜'
                        }
                      }),
                    ]
                  },
                  {
//                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -30,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '日祝'
                        }
                      })
                    ]
                  }
                ],
              },
            ],
          }),
        ]
      },
      {
        boxStlz: a('dw/10 f/n'),
        oClds: [
        ]
      },
    ],
  });

  const _bdys1 = [] as ht.ls;
//  $i111Ls
  $i11z?.i111s?.filter( ( i111z:ht.dz ) => i111z._dlt != 1 )
  .map( ( i111z:ht.dz, _nIdx: ht.n ) => {
    _bdys1.push({
      boxStlz: a(`bc/lt${_nIdx == 0 ? 1 : 9} bs/dt bwt/1 dh/10 f/n pt/1`),
      cellCs: [
        {
          boxStlz: a('dh/f fd/ccc'),
          oClds: [
            cr.c(IptC.S, {
              key: -10,
              cz: {
                bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                iptType: 'text',
                vle: i111z._icn ?? '',
                onChg: ( _s: ht.s ) => {
                  i111z._icn = _s;
                }
              }
            })
          ]
        },
        {
//          boxStlz: a('dh/f f/2 fd/ccc'),
          boxStlz: a('dh/f dw/10 f/n fd/ccc'),
          oClds: [
            cr.c(IptC.S, {
              key: -10,
              cz: {
                bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                iptType: 'text',
                vle: i111z._pfx ?? '',
                onChg: ( _s: ht.s ) => {
                  i111z._pfx = _s;
                }
              }
            })
          ]
        },
        {
//          boxStlz: a('dh/f f/1 fd/cac'),
          boxStlz: a('dh/f dw/10 f/n fd/cac'),
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              ... _abtz.cldz.hdrCz.textCz,
              boxStlz: a('f/1 fd/ccc'),
              textz: {
                pfx: '開始時刻'
              }
            }),
            cr.c(TextC.N, {
              key: -20,
              ... _abtz.cldz.hdrCz.textCz,
              boxStlz: a('f/1 fd/ccc'),
              textz: {
                pfx: '終了時刻'
              }
            }),
          ]
        },
        {
          boxStlz: a('dh/f f/3 fd/cac'), // １種／通常
          oClds: [
            cr.c(GridC.N, {
              key: -10,
              abtType: 'nolineCmnz',
              lineCs: [
                {
                  boxStlz: a('mb/0'),
                  cellCs: [
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -10,
                          cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i111z.i111a1111i ?? '',
                            onChg: ( _s: ht.s ) => {
                              i111z.i111a1111i = _s;
                              i111z.i111a1112i = _s;
                              i111z.i111a1113i = _s;
                              i111z.i111a1121i = _s;
                              i111z.i111a1122i = _s;
                              i111z.i111a1123i = _s;
                              i111z.i111a1211i = _s;
                              i111z.i111a1212i = _s;
                              i111z.i111a1213i = _s;
                              i111z.i111a1221i = _s;
                              i111z.i111a1222i = _s;
                              i111z.i111a1223i = _s;
                              _frcUdt();
                            }
                          }
                        }),
                      ]
                    },
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -20,
                          cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i111z.i111a1112i ?? '',
                            onChg: ( _s: ht.s ) => {
                              i111z.i111a1112i = _s;
                            }
                          }
                        }),
                      ]
                    },
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -30,
                          cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i111z.i111a1113i ?? '',
                            onChg: ( _s: ht.s ) => {
                              i111z.i111a1113i = _s;
                            }
                          }
                        }),
                      ]
                    }
                  ],
                },
              ],
            }),
            cr.c(GridC.N, {
              key: -20,
              abtType: 'nolineCmnz',
              lineCs: [
                {
                  boxStlz: a('mb/0'),
                  cellCs: [
                    {
//                      boxStlz: a('fd/rac'),
                      oClds: [
                        cr.c(IptC.S, {
                          key: -10,
                          cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i111z.i111a2111i ?? '',
                            onChg: ( _s: ht.s ) => {
                              i111z.i111a2111i = _s;
                              i111z.i111a2112i = _s;
                              i111z.i111a2113i = _s;
                              i111z.i111a2121i = _s;
                              i111z.i111a2122i = _s;
                              i111z.i111a2123i = _s;
                              i111z.i111a2211i = _s;
                              i111z.i111a2212i = _s;
                              i111z.i111a2213i = _s;
                              i111z.i111a2221i = _s;
                              i111z.i111a2222i = _s;
                              i111z.i111a2223i = _s;
                              _frcUdt();
                            }
                          }
                        }),
                      ]
                    },
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -20,
                          cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i111z.i111a2112i ?? '',
                            onChg: ( _s: ht.s ) => {
                              i111z.i111a2112i = _s;
                            }
                          }
                        }),
                      ]
                    },
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -30,
                          cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i111z.i111a2113i ?? '',
                            onChg: ( _s: ht.s ) => {
                              i111z.i111a2113i = _s;
                            }
                          }
                        }),
                      ]
                    }
                  ],
                },
              ],
            }),
          ]
        },
        {
          boxStlz: a('dh/f f/3 fd/cac'), // １種／夏時間
          oClds: [
            cr.c(GridC.N, {
              key: -10,
              abtType: 'nolineCmnz',
              lineCs: [
                {
                  boxStlz: a('mb/0'),
                  cellCs: [
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -40,
                          cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i111z.i111a1121i ?? '',
                            onChg: ( _s: ht.s ) => {
                              i111z.i111a1121i = _s;
                            }
                          }
                        }),
                      ]
                    },
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -50,
                          cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i111z.i111a1122i ?? '',
                            onChg: ( _s: ht.s ) => {
                              i111z.i111a1122i = _s;
                            }
                          }
                        }),
                      ]
                    },
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -60,
                          cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i111z.i111a1123i ?? '',
                            onChg: ( _s: ht.s ) => {
                              i111z.i111a1123i = _s;
                            }
                          }
                        }),

                      ]
                    }
                  ],
                },
              ],
            }),
            cr.c(GridC.N, {
              key: -20,
              abtType: 'nolineCmnz',
              lineCs: [
                {
                  boxStlz: a('mb/0'),
                  cellCs: [
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -40,
                          cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i111z.i111a2121i ?? '',
                            onChg: ( _s: ht.s ) => {
                              i111z.i111a2121i = _s;
                            }
                          }
                        }),
                      ]
                    },
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -50,
                          cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i111z.i111a2122i ?? '',
                            onChg: ( _s: ht.s ) => {
                              i111z.i111a2122i = _s;
                            }
                          }
                        }),
                      ]
                    },
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -60,
                          cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i111z.i111a2123i ?? '',
                            onChg: ( _s: ht.s ) => {
                              i111z.i111a2123i = _s;
                            }
                          }
                        }),
                      ]
                    }
                  ],
                },
              ],
            }),

          ]
        },
        {
          boxStlz: a('dh/f f/3 fd/cac'), // ２種／通常
          oClds: [
            cr.c(GridC.N, {
              key: -10,
              abtType: 'nolineCmnz',
              lineCs: [
                {
                  boxStlz: a('mb/0'),
                  cellCs: [
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -10,
                          cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i111z.i111a1211i ?? '',
                            onChg: ( _s: ht.s ) => {
                              i111z.i111a1211i = _s;
                            }
                          }
                        }),
                      ]
                    },
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -20,
                          cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i111z.i111a1212i ?? '',
                            onChg: ( _s: ht.s ) => {
                              i111z.i111a1212i = _s;
                            }
                          }
                        }),
                      ]
                    },
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -30,
                          cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i111z.i111a1213i ?? '',
                            onChg: ( _s: ht.s ) => {
                              i111z.i111a1213i = _s;
                            }
                          }
                        }),
                      ]
                    }
                  ],
                },
              ],
            }),
            cr.c(GridC.N, {
              key: -20,
              abtType: 'nolineCmnz',
              lineCs: [
                {
                  boxStlz: a('mb/0'),
                  cellCs: [
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -10,
                          cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i111z.i111a2211i ?? '',
                            onChg: ( _s: ht.s ) => {
                              i111z.i111a2211i = _s;
                            }
                          }
                        }),
                      ]
                    },
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -20,
                          cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i111z.i111a2212i ?? '',
                            onChg: ( _s: ht.s ) => {
                              i111z.i111a2212i = _s;
                            }
                          }
                        }),
                      ]
                    },
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -30,
                          cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i111z.i111a2213i ?? '',
                            onChg: ( _s: ht.s ) => {
                              i111z.i111a2213i = _s;
                            }
                          }
                        }),
                      ]
                    }
                  ],
                },
              ],
            }),
          ]
        },
        {
          boxStlz: a('dh/f f/3 fd/cac'), // ２種／夏時間
          oClds: [
            cr.c(GridC.N, {
              key: -10,
              abtType: 'nolineCmnz',
              lineCs: [
                {
                  boxStlz: a('mb/0'),
                  cellCs: [
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -40,
                          cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i111z.i111a1221i ?? '',
                            onChg: ( _s: ht.s ) => {
                              i111z.i111a1221i = _s;
                            }
                          }
                        }),
                      ]
                    },
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -50,
                          cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i111z.i111a1222i ?? '',
                            onChg: ( _s: ht.s ) => {
                              i111z.i111a1222i = _s;
                            }
                          }
                        }),
                      ]
                    },
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -60,
                          cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i111z.i111a1223i ?? '',
                            onChg: ( _s: ht.s ) => {
                              i111z.i111a1223i = _s;
                            }
                          }
                        }),

                      ]
                    }
                  ],
                },
              ],
            }),
            cr.c(GridC.N, {
              key: -20,
              abtType: 'nolineCmnz',
              lineCs: [
                {
                  boxStlz: a('mb/0'),
                  cellCs: [
                    {
//                      boxStlz: a('fd/rac'),
                      oClds: [
                        cr.c(IptC.S, {
                          key: -40,
                          cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i111z.i111a2221i ?? '',
                            onChg: ( _s: ht.s ) => {
                              i111z.i111a2221i = _s;
                            }
                          }
                        }),
                      ]
                    },
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -50,
                          cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i111z.i111a2222i ?? '',
                            onChg: ( _s: ht.s ) => {
                              i111z.i111a2222i = _s;
                            }
                          }
                        }),
                      ]
                    },
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -60,
                          cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i111z.i111a2223i ?? '',
                            onChg: ( _s: ht.s ) => {
                              i111z.i111a2223i = _s;
                            }
                          }
                        }),
                      ]
                    }
                  ],
                },
              ],
            }),

          ]
        },
        {
//          boxStlz: a('dh/f f/1 fd/cac'),
          boxStlz: a('dh/f dw/10 f/n fd/cac'),
          oClds: [
            hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ?
            cr.c(BtnC.N, {
              key: -10,
              ... _abtz.cldz.bdyCz.btnDltCz,
              bfrIconCz: {},
              lblCz: {},
              pslPtyz: {
                onPress: () => {
                  i111z._dlt = 1;
                  _frcUdt();
                },
              }
            })
            : null,
          ]
        },
      ],
    });
  });  
  if ( hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ) {
    _bdys1.push({
      cellCs: [
        {
          oClds: [
            cr.c(BtnC.N, {
              key: -10,
              ... _abtz.cldz.bdyCz.btnAddCz,
              bfrIconCz: {},
              lblCz: {},
              pslPtyz: {
                onPress: () => {
//                  $i111Ls.push({
                  $i11z?.i111s.push({
//                    i111i17r1k: -1,
                    i111i11r1k: -1,
                  });
                  _frcUdt();
                },
              }
            })
          ]
        },
      ],
    });
  }

  return (
    cr.c(BoxC.N, {
      key: -10,
      boxStlz: a('dw/f fd/csc'),
      oClds: [

        hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
        cr.c(TextC.N, {
          key: -5,
          abtType: 'rmkCmnz',
          boxStlz: a(`dw/f fd/rsc mb/1`),
          textz: {
            pfx: '※：必須'
          }
        })
        : null,

        cr.c(GridC.N, {
          key: -10,
          abtType: 'nolineCmnz',
          boxStlz: a('dwx/60 mb/1 mh/a'),
          lineCs: [
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        textz: {
                          pfx: '時間帯区分ID',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
//                              vle: $i11rDz._icn ?? '',
                              vle: $i11z?.i11rz._icn ?? '',
                              onChg: ( _s: ht.s ) => {
//                                $i11rDz._icn = _s;
                                $i11z.i11rz._icn = _s;
                              },
                            }
                          })
                        ],
                      },
                      omtCz: 
                        hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        textz: {
                          pfx: '時間帯区分名',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
//                              vle: $i11rDz._pfx ?? '',
                              vle: $i11z?.i11rz._pfx ?? '',
                              onChg: ( _s: ht.s ) => {
//                                $i11rDz._pfx = _s;
                                $i11z.i11rz._pfx = _s;
                              },
                            }
                          })
                        ],
                      },
                      omtCz: 
                        hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            },
/*
            {
              cellCs: [
                {
                  boxStlz: a('dw/15 f/n'),
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        textz: {
                          pfx: '（夏時間）',
                        }
                      },
                      cttCz: {
                        oClds: [
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a('dw/10'),
                        textz: {
                          pfx: '開始月：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i11z?.i11rz.i11ra1100i ?? '0',
                              onChg: ( _s: ht.s ) => {
                                $i11z.i11rz.i11ra1100i = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a('dw/10'),
                        textz: {
                          pfx: '終了月：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
//                              vle: $i11rDz.i11ra1200i ?? '0',
                              vle: $i11z?.i11rz.i11ra1200i ?? '0',
                              onChg: ( _s: ht.s ) => {
//                                $i11rDz.i11ra1200i = _s;
                                $i11z.i11rz.i11ra1200i = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
*/
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a('dw/16'),
                        textz: {
                          pfx: '（夏時間）',
                        }
                      },
                      cttCz: {
                        oClds: [

                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      boxStlz: a('dw/22'),
                      lblCz: {
                        boxStlz: a('dw/10'),
                        textz: {
                          pfx: '開始月：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i11z?.i11rz.i11ra1100i ?? '0',
                              onChg: ( _s: ht.s ) => {
                                $i11z.i11rz.i11ra1100i = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),

                    cr.c(LblC.N, {
                      key: -20,
                      ... _abtz.crtz.lblCz,
                      boxStlz: a('dw/22'),
                      lblCz: {
                        boxStlz: a('dw/10'),
                        textz: {
                          pfx: '終了月：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
//                              vle: $i11rDz.i11ra1200i ?? '0',
                              vle: $i11z?.i11rz.i11ra1200i ?? '0',
                              onChg: ( _s: ht.s ) => {
//                                $i11rDz.i11ra1200i = _s;
                                $i11z.i11rz.i11ra1200i = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),

                        ],
                      }
                    }),
                  ]
                },
              ]
            },
          ]
        }),

        cr.c(TblC.N, {
          key: -30,
          ... _abtz.cldz.tblCz,
          srlCz: {
            srlStlz: {
              otrz: a('dwx/120'),
            }
          },
          hdrCz: {
            lineCs: _hdrs1
          },
          bdyCz: {
            lineCs: _bdys1
          }
        }),

      ]
    })
  );
};

